var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeospoofSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 12.05 2.5 9.25 4.275 6.9C4.5875 6.4875 5.175 6.4125 5.5875 6.725C6 7.0375 6.0875 7.625 5.775 8.0375C4.25 10.05 3.4375 12.4625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375C14.4875 3.4375 14.0625 3.0125 14.0625 2.5C14.0625 1.9875 14.4875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.6875C9.6625 24.6875 5.3125 20.3375 5.3125 15C5.3125 14.4875 5.7375 14.0625 6.25 14.0625C6.7625 14.0625 7.1875 14.4875 7.1875 15C7.1875 19.3125 10.6875 22.8125 15 22.8125C19.3125 22.8125 22.8125 19.3125 22.8125 15C22.8125 10.6875 19.3125 7.1875 15 7.1875C14.4875 7.1875 14.0625 6.7625 14.0625 6.25C14.0625 5.7375 14.4875 5.3125 15 5.3125C20.3375 5.3125 24.6875 9.6625 24.6875 15C24.6875 20.3375 20.3375 24.6875 15 24.6875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.9375C14.4875 20.9375 14.0625 20.5125 14.0625 20C14.0625 19.4875 14.4875 19.0625 15 19.0625C17.2375 19.0625 19.0625 17.2375 19.0625 15C19.0625 12.7625 17.2375 10.9375 15 10.9375C14.4875 10.9375 14.0625 10.5125 14.0625 10C14.0625 9.4875 14.4875 9.0625 15 9.0625C18.275 9.0625 20.9375 11.725 20.9375 15C20.9375 18.275 18.275 20.9375 15 20.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeospoofSearch);
export default __webpack_public_path__ + "static/media/geospoofSearch.aae4a4438ff904064c53f39bc2c30f68.svg";
export { ForwardRef as ReactComponent };